export const texts = {
  title: 'Šta se desilo nakon ubistva Nizame Hećimović?',
  description:
    'Bijes javnosti, šok i nevjerica nakon brutalnog ubistva Nizame Hećimović uživo na Instagramu godinu dana kasnije rezultirali su jednom izmjenom zakona u malom dijelu Bosne i Hercegovine i više novca za sigurne kuće u drugom dijelu zemlje. Nakon njenog ubistva, žrtve su počele sve više da prijavljuju rodno nasilje.',
  share: 'Podijelite',

  title_2: 'Na šta vas asocira ime Nizame Hećimović?',
  silhouettes_1: 'Marina',
  silhouettes_2: 'Užas svakodnevice',
  silhouettes_3: 'Senad',
  silhouettes_4: 'Žalost, žalost',
  silhouettes_5: 'Budimirka',
  silhouettes_6: 'Nešto što se ne treba nikada ponoviti',
  silhouettes_7: 'Marina',
  silhouettes_8: 'Strašno',
  silhouettes_9: 'Jusuf',
  silhouettes_10: 'Na veliku nepravdu nad ženama',

  screen3_1:
    'Kada žena bude ubijena, telefon zvoni. A u posljednjih godinu dana, telefoni, čini se, zvone više nego ikada. Broj prijava rodnog nasilja u Bosni i Hercegovini raste, rekli su za Radio Slobodna Evropa iz nekoliko organizacija koje se bave zaštitom žrtava nasilja. Isto kažu i iz policije.',
  screen3_2:
    'Samo tokom augusta prošle godine došlo je do povećanja poziva na SOS telefon za 148 posto u odnosu na august 2022. godine, kažu iz Sigurne kuće u Sarajevu.',
  screen3_3:
    '"Razlog ovako velikog povećanja broja poziva na SOS telefon može se povezati sa ubistvom Nizame Hećimović", pojašnjavaju.',

  screen4_1:
    'Nizama Hećimović ubijena je 11. avgusta 2023. u Gradačcu. Ubistvo je počinio njen bivši partner Nermin Sulejmanović koji je istog dana ubio još dvije osobe i počinio samoubistvo. Prije ubistva Nizama je od suda i policije zatražila izricanje mjera i zabranu prilaska i uznemiravanja. Zahtjev je odbijen jer prema riječima suda nije bilo dokaza. Nekoliko dana kasnije, ubijena je uživo na Instagramu.',
  screen4_2:
    'Prema podacima Visokog sudskog i tužilačkog vijeća samo u periodu između 2021. i 2022. ubijeno je 19 žena u BiH. Među njima nisu Nizama Hećimović, Emira Maslan, Amra Kahrimanović, žene ubijene godinu kasnije. Među statistikama nije ni 84 posto slučajeva koji nikada ne budu prijavljeni.',
  screen5: (
    <p>
      Među onima koje jesu prijavile nasilje i ušle u sistem zaštite zbog rodnog nasilja su{' '}
      <b>Ana</b>, <b>Elma</b>, <b>Sanela</b> i <b>Maida</b>. Ovo nisu njihova imena, zaštićene su
      zbog sigurnosti.
    </p>
  ),

  screen6: 'Šta im se dogodilo?',

  answers_1: 'Šta im se dogodilo?',
  answers_2: 'Ana',
  answers_3:
    'Prvo fizičko nasilje sam doživjela prije dvije i po godine. Bili smo razdvojeni šest mjeseci, ali sam nažalost oprostila. Jedno vrijeme je sve bilo normalno i onda je opet njegova priroda počela izbijati na površinu. Tu noć kad se desio drugi fizički napad, osim batina, doživjela sam veliko poniženje, jer sam imala menstruaciju, on je kidao veš i sve sa mene. Bila sam pretučena, krvava, osramoćena.',
  answers_4: 'Maida',
  answers_5:
    'Prišao je i uhvatio me za vrat. To su vidjela djeca i počela su da plaču. Rekla sam im da sam dobro i on mi je onda udario šamar. Djeca su istrčala, on je otišao. Za nekoliko dana je nazvao jedno od djece i rekao da paze gdje hodaju da bi mogli dobiti metak u glavu i da bi mene mogli naći mrtvu.  ',
  answers_6: 'Elma',
  answers_7:
    'Nije bilo fizički nasilja, bilo je psihički. Kad odvedem dijete doktoru, kad odem negdje, govorio bi da sam kurva, da ga varam. Znao me istjerati napolje u neko doba noći. (…) Došao mi je sa sjekirom i rekao mi je da će me isjeći i biće mi gore nego onoj u Gradačcu. ',
  answers_8: 'Sanela',
  answers_9:
    "Mislila sam da ću imati finu porodicu, da ću fino da živim. Čitavo vrijeme sam bila za njega kurva, drolja, a zbog njega sam sve ostavila. (...) Jako me uhvatio za kosu, kaže, 'možeš doći ovamo da vodimo ljubav'. Ja sam se nasmijala. Rekla sam, pusti mi kosu. Nakon batina, izbijanja zuba ti hoćeš da vodim ljubav s tobom. To je van sve pameti. I on je ono baš krenuo. Onda sam ja zovnula mamu i rekla sam joj 'ovo mi je sad uradio iako si ti u sobi'.",

  screen8: 'Kako su se odlučile na prijavu?',

  answers_10: 'Kako su se odlučile na prijavu?',
  answers_11: 'Maida',
  answers_12:
    'Prvo nasilje, hvatanje za vrat i šamar nisam prijavljivala. Ali kad su pale tako ozbiljne riječi, znam šta je sve u stanju, odlučila sam otići u policiju i prijaviti ga.',
  answers_13: 'Ana',
  answers_14:
    'Tri dana on je bio kući i kljukao me lijekovima protiv bolova, za smirenje, mazao gelovima da mi prođu modrice. Plakao, govorio da sam kurva, satima sjedio i gledao u mene. To mi je bilo gore od batina i znala sam da čim izađe iz kuće da ću ga prijaviti i nikad više se neću vratiti u pakao.',
  answers_15: 'Sanela',
  answers_16:
    'Krenula sam, obukla jaknu i uzela svoje dijete. Da bi njegova mati stala ispred mene i rekla, nećeš dijete voditi. Rekoh, to je moje dijete. Da bi on ušao i mene uhvatio za ruku, da me izvuče napolje. Ja sam zgrabila telefon, rekoh, sad ću ti policiju nazvati. Kako sam ja rekla policiju, on je mene pustio. I njegova mati kaže, pošto policiju zoveš mom sinu, ovaj prag više nećeš preći. Rekoh, svakako ga, gospođo, neću preći.  I nazvala sam policiju. ',
  answers_17: 'Elma',
  answers_18:
    'Pošto sam više puta odlazila i vraćala se, mislila sam da će se promijeniti. Sve sam gledala radi djece, pomiriš se radi djeci, bit će bolje, trpila sam.',

  screen10: 'Kakvu pomoć su dobile?',

  faces_1: (
    <>
      <p>
        Elma je napustila supruga nakon trinaest godina psihičkog maltretiranja. Četvero djece,
        nekoliko pokušaja odlazaka na kraju su rezultirali sa njenim životom u sigurnoj kući. Prvo
        se sklonila u podstanarsku kuću, a kada ju je suprug pronašao, policiju je nazvala
        nastavnica njenog djeteta. Suprug je zadržan u pritvoru jednu noć, a njoj je Centar za
        socijalni rad ponudio da ode u sigurnu kuću.
      </p>
      <p>
        "Razmišljala sam da li da idemo u sigurnu kuću ili da nađem stan. Ako nađem neki stan,
        dolazit će mi. I tako da sam pristala da dođem u sigurnu kuću sa svojim djecom." Danas čeka
        razvod braka.
      </p>
    </>
  ),
  faces_2: (
    <>
      <p>
        I Sanela je nakon deset godina maltretiranja i fizičkog nasilja tokom dvije trudnoće spas
        našla u sigurnoj kući. Nakon pomoći prijatelja, otišla je u policiju i dala izjavu.
      </p>
      <p>
        "Policajac je pitao gdje ću. Rekla sam da ne znam i onda sam mu rekla da sam čula za sigurnu
        kuću i da li postoji mogućnost da smjeste mene i dijete", priča Sanela. U proces se
        uključila i socijalna služba, a Sanela je od tada sa svojom djecom u sigurnoj kući.
      </p>
    </>
  ),
  faces_3: (
    <>
      <p>U sigurnom smještaju se nalazi i Ana.</p>
      <p>"Čim je izašao sa parkinga, nazvala sam SOS telefon i ispričala sve."</p>
      <p>
        Jutro nakon toga otišla je u jednu od organizacija koja joj je i ranije pomagala.
        Organizovali su joj pregled, policiju, socijalno. Navodi da se osjećala više zaštićenom nego
        kada je prvi put otišla od supruga, a danas ima i advokaticu koja je njen slučaj preuzela
        besplatno.
      </p>
    </>
  ),
  faces_4: (
    <>
      <p>
        Maidin suprug je dobio zabranu prilaska i uznemiravanja. Proces je prošla od policije,
        tužilaštva, suda. U svemu tome imala je pomoć osobe koja je dio 4P mreže pomagačica, žena
        obučenih da pomognu ženama koje se suočavaju sa nasiljem.
      </p>
      <p>
        "Nisam ni znala da postoje udruženja za zaštitu žena koje imaju probleme sa nasiljem." Da
        ima pravo na osobu povjerenja rekao joj je inspektor u policiji. Danas čeka razvod braka i
        kaže da bi cijeli sistem zaštite mogao biti bolji.
      </p>
      <p>
        "On je dobio samo zabranu prilaska, šta to njemu znači, mogao bi doći u bilo koje doba dana
        i napraviti šta je zamislio u glavi", kaže Maida.
      </p>
      <p>
        Prema riječima Fondacije "Udružene žene" iz Banja Luke spora kaznena politika i sankcije za
        učinioce nasilja su i dalje karika koja “nedostaje i koja otežava položaj žrtava nasilja u
        BiH.”
      </p>
      <p>
        Iz Fondacije Lara kažu kako smatraju da bi smanjenje administrativnih procedura za smještaj
        žrtava doprinio "slobodnijem, nesmetanom i jednostavnijem pristupu sigurnim kućama".
      </p>
    </>
  ),

  icons_1: 'Šta se desilo nakon ubistva Nizame Hećimović? ',
  icons_2: 'Kliknite na ikonu da pročitate više',
  icons_3: 'Protesti',
  icons_4: 'Policija',
  icons_5: 'Zakoni',
  icons_6: 'Sistemi zaštite',
  icons_7: (
    <>
      <p>
        Nekoliko sati nakon informacije o ubistvu žene u Gradačcu, aktivistice sa zahtjevima izlaze
        na ulice u Sarajevu, Mostaru i drugim gradovima. Traže veću zaštitu za žrtve, hitno
        postupanje u slučajevima istraga, strožije kazne za počinioce, kao i zakonske izmjene koje
        bi bile usklađene sa Istanbulskom konvencijom. No, kako kaže Jadranka Miličević iz Fondacije
        Cure skoro ništa od toga nije urađeno.
      </p>
      <p>
        "Još uvijek nemamo usvojen novi Krivični zakon, kao i Zakon o zaštiti nasilja u porodici,
        koji su još uvijek u pripremi,” pojašnjava Miličević i dodaje da je nacrt zakona
        predstavljen ovih dana, a da uprkos obećanjima federalnog Ministarstva pravde krivični zakon
        još uvijek nije predstavljen.
      </p>
      <p>
        “Sporost oko usvajanja ovako važnih zakona je pokazatelj odnosa predstavnika/ca izvršnih i
        zakonodavnih institucija spram problema povećanog nasilja nad ženama."
      </p>
      <p>
        Oko 48 posto žena u BiH preživjelo je seksualno i rodno zasnovano nasilje, navode iz
        Fondacije Cure, a čak 84 posto slučajeva se nikada ne prijavi. Uprkos svim slučajevima koji
        budu prijavljeni i onima koji na kraju nažalost dođu i do javnosti, mali broj ljudi izađe na
        ulice.
      </p>
      <p>
        "Primjetili smo da je motivacija veliki problem, jer građani/ke smatraju da neodgovornost
        predstavnika/ca institucija i nesprovođenje sadašnjih zakona obeshrabruje građane/ke da
        izađu na ulice u većem broju,” kaže Miličević.
      </p>
      <p>
        Također, dodaje da u većini slučajeva smatra se da je nasilje nad ženama “privatni problem".
      </p>
    </>
  ),
  icons_8: (
    <>
      <p>
        Prvi korak u suočavanju sa nasiljem je prijava nasilja, policiji na 122 ili na jedan od dva
        SOS broja aktivna u Bosni i Hercegovini. Prema podacima nekoliko kantonalnih ministarstava
        unutrašnjih poslova u zadnjih godinu dana došlo je do povećanog broja prijava nasilja. Više
        prijava stiglo je i u Tuzlanski kanton, u kojem je u avgustu 2023. ubijena Nizama. Tokom
        2022. u ovom kantonu prijavljena su 132 slučaja, dok je prošle godine prijavljeno 203
        slučajeva. Kako iz ovog MUP-a pojašnjavaju za RSE, policajci kod prijave postupaju u skladu
        sa Zakonom o zaštiti od nasilja u porodici FBiH.
      </p>
      <p>Kako to funkcioniše?</p>
      <p>
        Kada policija zaprimi prijavu nasilja, nakon prikupljanja dokaza o postojanju nasilja, u
        roku od 12 sati policijski službenici sudu podnose zahtjev za izricanje mjera zabrane uz
        dokumente koji potvrđuju navode o nasilju.
      </p>
      <p>
        "O prijavi nasilja policijski službenici obavještavaju i nadležni Centar za socijalni rad,
        te poučavaju žrtvu o mogućem zbrinjavanju u sigurne kuće," pojašnjavaju iz MUP-a TK. Dodaju
        i da policijski službenici postupaju promptno, kod prijave, ali i kod narušavanja izricanja
        mjere zabrane.
      </p>
      <p>
        “Ali izrečene mjere zabrane počiniocu nasilja ne znače da policijski službenici ‘čuvaju
        žrtvu’, već da će odmah po saznanju reagovati u skladu sa zakonskim ovlašenjima u slučaju
        kršenja istih.”
      </p>
      <p>
        Osim ovog zakona, Krivičnog zakona i drugih relevantnih, postoji i pravilnik o načinu
        provođenja zaštitnih mjera za počinioce nasilja. Kako navode u toku je rad na dopunama
        pravilnika “ u dijelu koji se odnosi na procjenu rizika u cilju poboljšanja sistema
        zaštite.”
      </p>
      <p>
        Upravo je procjena rizika od smrtnosti, ozbiljnosti situacije i rizika od ponavljanja
        nasilja jedan od zahtjeva i Istanbulske konvencije. U RS-u ovo je zakonska obaveza već
        nekoliko godina, dok će u Federaciji BiH ovo pitanje biti regulisano ukoliko se usvoji novi
        Zakon o zaštiti od nasilja u porodici, rekli su iz Sigurne mreže.
      </p>
      <p>
        Povećan broj prijava navode i iz Zeničko-dobojskog kantona u kojem djeluje i jedna od
        sigurnih kuća. Kako navode iz MUP-a ovog kantona broj prijavljenih slučajeva raste i zbog
        njihovih, ali i aktivnosti drugih organizacija, kojima ukazuju na značaj prijavljivanja
        nasilja.
      </p>
      <p>
        “Smatramo da smo takvim pristupom izgradili povjerenje kod žrtava i ohrabrili ih da
        prijavljuju takve slučajeve,” navode iz MUP-a ZDK.
      </p>
      <p>
        Jedna od takvih aktivnosti je i obuka iz oblasti rodno zasnovanog nasilja koja je održana u
        sklopu Policijske akademije uz podršku OSCEa-a.
      </p>
      <p>
        Misija pruža podršku aktivnostima Ministarstva unutrašnjih poslova i Policijske akademije
        FBiH koje se odnose na modernizaciju nastavnog plana i programa prema kojem će kadeti
        Policijske akademije učiti o rodno zasnovanom nasilju i nasilju u porodici u okviru redovne
        obuke”, navode iz OSCE-a.
      </p>
    </>
  ),
  icons_9: (
    <>
      <p>
        Konkrentniji zakoni, bolja implementacija i kazna za počinioce, edukacija osoblja uključenog
        u zaštitu i pomoć žrtvi, standardni su zahtjevi i na brojnim protestima organizovanim širom
        BiH nakon brojnih slučajeva nasilja.
      </p>
      <p>
        BiH je potpisnica svih važnijih međunarodnih sporazuma koji osiguravaju zaštitu od nasilja
        nad ženama prije svega Konvencije UN-a o eliminaciji svih oblika diskriminacije žena.
      </p>
      <p>
        U zemlji su također na snazi krivični zakoni, zakoni o zaštiti nasilja u porodici, zakon o
        zabrani diskriminacije. No, uprkos ratificiranju Istanbulske konvencije, zakoni nisu
        usklađeni.
      </p>
      <p>
        Jedina izmjena učinjena je u Brčko distriktu gdje je na proljeće 2024. došlo do usvajanja
        novog Krivičnog zakona. Ovim je Brčko distrikt postalo i jedini dio BiH u kojem je silovanje
        definisano kao nedostatak pristanka.
      </p>

      <p>
        Kako navode iz Agencije za ravnopravnost spolova za RSE Vlada Republike Srpske je pripremila
        novi Zakon o zaštiti od nasilja u porodici i nasilja protiv žena, no on nije prošao
        zakonodavnu procedure u Narodnoj skupštini RS, pa će biti potrebno da se ponovi čitav
        proces. U Federaciji BIH je pripremljen sličan zakon koji je prihvaćen u prvom čitanju i u
        toku je javna rasprava i priprema nacrta za drugo čitanje i usvajanje.
      </p>
      <p>
        “Sistem postoji, odnosno pravni I institucionalni okvir. Međutim, isti nije dovoljno
        usklađen sa standardima i obavezama koje smo preuzeli ratifikacijom Istanbulske konvencije
        Vijeća Europe,” navode iz Agencije za ravnopravnost spolova BiH.
      </p>
      <p>
        Uprkos svim postojećim zakonskim okvirima, Istanbulskoj konvenciji, rodno uslovljeno nasilje
        je i dalje sveprisutno, što je u posljednjem izvještaju za BiH naglasila i Evropska
        komisija.
      </p>
      <p>
        "Često u praksi se ne implementira ono što je na papirima", naglasila je Sabiha Husić,
        direktorica sigurne kuće u koju su se tokom decenija rada od nasilnika sklonile brojne žene,
        uključujući i žrtve ratnog silovanja.
      </p>
    </>
  ),
  icons_10: (
    <>
      <p>
        Sve žene sa kojima smo razgovarali dobile su neki oblik pomoći od nevladinih organizacija.
        Iz Udružene žene Banja Luka kažu da je u zadnjih godinu dana vidljiv porast svih usluga koje
        pružaju, od psihološke i besplatne pravne pomoći do sigurne kuće.
      </p>
      <p>
        "Ono što se promijenilo jeste izlazak iz anonimnosti i povećan broj konkretnih intervencija,
        jer samim otkrivanjem identiteta može se na adekvatan način i odreagovati i pristupiti žrtvi
        nasilja. Takođe, primjetno je da se na SOS liniju sve više javljaju mlađe žene koje su
        nasilje trpile kraći vremenski period i žele da iz takve zajednice izađu."
      </p>
      <p>Povećan broj poziva bilježe i u Sigurnoj kući u Sarajevu.</p>
      <p>
        "Nakon femicida u Bosni i Hercegovini žrtve nasilje bile su u strahu za svoj život, žene i
        njihovi srodnici su se informisali na koji način se žrtve mogu zaštititi, iskazivali su
        nepovjerenje prema institucijama pogotovo u manjim lokalnim zajednicama."
      </p>
      <p>
        Kako kažu broj poziva povećao se i za 45 posto nakon ubistva Emire Maslan u Sarajevu, ali su
        primjetili još jedan trend rasta.
      </p>
      <p>
        "Povećan je broj poziva građana/ki koji imaju potrebu da putem SOS telefona prijavljuju
        nasilje u svom komšiluku s ciljem sprečavanja većih posljedica."
      </p>
      <p>
        Na teritoriji BiH postoji osam sigurnih kuća sa ukupno 200 raspoloživih mjesta za žene i
        djecu žrtve nasilja. Sigurne kuće nalaze se u Sarajevu, Tuzli, Bihaću, Zenici, Mostaru,
        Modriči, Banja Luci i Bijeljini.
      </p>
      <p>
        Od toga, pet sigurnih kuća sa područja Federacije BiH će ove godine dobiti ukupno do milion
        konvertibilnih maraka od Ministarstva rada i socijalne politike kako bi pomogli žrtvama
        nasilja. Radi se o povećanom iznosu u odnosu na ranije godine.
      </p>
      <p>
        Kako pojašnjava Sabiha Husić, direktorica Medice, radi se o povećanom iznosu koji je prije
        tri-četiri godine iznosio tek 168 hiljada KM. Povećanje sredstava za sigurne kuće je i
        poruka žrtvama nasilja da "nisu same" kaže Husić. Novac će također pomoći da se očuvaju
        stručni kapaciteti sigurnih kuća, a i žrtve se neće pitati ko će platiti i kako.
      </p>
      <p>
        "Neće se pitati ko će to platiti i kako. Neće decenijama šutiti, nositi se sa strahom i
        pitati se da li će im se vjerovati ako progovore. Institucije će ozbiljnije prihvatati i
        poštovati sigurne kuće, odnosno mjeru zbrinjavanja i zaštite u sigurnim kućama", kaže Husić.
      </p>
      <p>
        "Hoću da vjerujem da će i počinioci nasilja shvatiti da nasilje neće biti tolerisano i da će
        svaka žrtva nasilja dobiti brzu, efikasnu i institucionaliziranu podršku."
      </p>
      <p>
        Veći broj smještaja u sigurne kuće zabilježen je i kod Fondacije Lara. Kako navodi njihov
        stručni tim, obzirom da su sigurne kuće dio sistema već 20 godina, jasno je da su neophodne.
      </p>
      <p>
        "Vrlo je važno stabilno finansiranje sigurnih kuća, jer na takav način bi riješili pitanje
        opstanka i efikasnijeg rada istih. Da bi sistem bio efikasniji mora se dalje razvijati i
        specijalizirati."
      </p>
      <p>
        Osim sigurnih kuća, u zemlji postoji i 4P sistem kojeg sprovodi Centar ženskih prava Zenica.
        U njemu oko 60 žena pruža pomoć ženama u lokalnim zajednicama kako bi ostvarile svoja prava
        u sistemu zaštite. Ako nemaju nikoga ko ih može zastupati ili ako ne znaju kako funkcioniše
        proces, žene se mogu javiti direktno jednoj od pomagačica koja je obučena da im pomogne.
      </p>
    </>
  ),

  allTogether_1: 'Kako se danas osjećaju?',
  allTogether_2:
    'Osjećam se sjajno zato što više ne živim u strahu. Budem pod stresom kad uzme dijete jer me ucjenjuje, ali čim ga ne vidim i ne čujem, dobro sam.',
  allTogether_3:
    'Dobro sam, ali i dalje me je strah. Ja kad čujem njegov glas djecu kada nazove krenem se tresti.',
  allTogether_4:
    'Ovdje sam našla neku zanimaciju da bi nešto radila. Šutim, ako me nešto pitaš odgovorit ću, ako me ne pitaš neću. Planiram da idem dalje i da se borim za svoju djecu.',
  allTogether_5:
    'Vidjela sam da mogu sama. Da mora čovjek da se odluči, da ne treba da trpi. Apsolutno da ne moram ništa da trpim. I kad pogledam djecu daju mi vjetar u leđa, da skupim snage, da budem jaka, da idem daje, da živim.',

  screen13_1:
    'Jedna od tri žene tokom svog života doživi neki oblik nasilja. Svaki sat više od pet žena ubije neko iz njene porodice, pokazuju podaci UN Women. Dok ste vi ovo čitali, negdje je vjerovatno ubijena još jedna žena. Nasilje nad ženama najraširenije je kršenje ljudskih prava na svijetu, kažu Ujedinjene nacije.',
  screen13_2: 'No, žene koje su prijavile nasilje nadaju se da će sada imati svjetliju budućnost.',
  screen13_3:
    'Kako kaže Maida, nada se da će imati mir i da se neće plašiti. "Često navečer kad legnem zamislim šta može biti tokom noći, hoću li ja ustati svojoj djeci živa?"',
  screen13_4:
    'Niti jedan prijavljeni slučaj nije identičan kažu iz policije. No, trendovi kažnjavanja su slični.',
  screen13_5: (
    <>
      <a
        href="https://www.slobodnaevropa.org/a/nasilje-u-porodici-bosna-hercegovina-zene-/32366140.html"
        target="_blank"
      >
        Raniji podaci
      </a>{' '}
      Visokog sudskog i tužilačkog vijeća pokazali su da se najčešće izriču uslovne kazne, a manje
      zatvorske i novčane.
    </>
  ),
  screen13_6:
    'Kaznena politika u predmetima nasilja nad ženama je načelno blaga i uglavnom ne ostvaruje ciljeve generalne i specijalne prevencije, kažu i u Centru ženskih prava Zenica. U analitici slučajeva rodnog nasilja iz 2022. godine kako navode iz ovog Centra, u 95,5 posto slučajeva donesena je okrivljujuća presuda. No, kada se radi izricanju kazne zatvor je izrečen u 29 posto slučajeva, a u preko 65 posto počinitelj je uslovno osuđen.',

  screen14_1:
    'Koliko je rašireno nasilje nad ženama nikada nećemo znati jer se radi o zločinu koji se i najmanje prijavljuje. Na jedan prijavljeni slučaj nasilja u porodici dolazi još deset neprijavljenih slučajeva, kažu iz Fondacije Cure. Prijaviti nasilje, ići sa osobom sa kojom ste prije živjeli po sudovima nije lako kaže i Maida.',
  screen14_2:
    '"Nije se lako odlučiti, treba hrabrosti napustiti kuću, napustiti taj život, napustiti muža i doći u novu sredinu, prilagoditi se. Tako nešto kad ti se desi, treba psihički podnijeti."',
  screen14_3: 'Ali, niko ne treba trpiti nasilje kaže Sanela.',
  screen14_4:
    '"Kad sam vidjela (Nizamu) rekla sam sebi da se to i meni može desiti. Srećom nije, pa sam skupila snage i presjekla sam to."',

  screen15_1:
    'Nakon ubistva u Gradačcu protiv sutkinje je podignuta disciplinska tužba. Iz tužilaštva je saopšteno da nije bilo protupravnog djelovanja policije niti suda. U Sarajevskom otvorenom centru kažu da je 75 žena ubijeno u BiH od 2015. do 2022. godine.',
  screen15_2:
    'Nasilje se može prijaviti na broj policije 122 i na SOS brojeve: 1265 za Federaciju BiH i 1264 za Republiku Srpsku.',

  about_1: 'O projektu ',
  about_2: 'Ženske sjenke',
  about_3:
    'Stranica Radija Slobodna Evropa posvećena rodno zasnovanom nasilju. Ovdje pronađite priče onih koji su preživjeli nasilje, kao i svjedočenja porodica žena kojih više nema.',
  authors_1: 'Autorica: Una Čilić',
  authors_2: 'Saradnja: Aida Đugum i Arnes Grbešić',
  authors_3: 'Dizajn: Pangea Digital Dataviz team',
  follow: 'Pratite nas',
  copyright_1: 'Sva prava zadržana. Radio Free Europe / Radio Liberty ©',
  copyright_2: 'RFE/RL, Inc.',
};
